import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { INSTAGRAM_URL, YOUTUBE_URL, WHATSAPP_NUMBER, openWhatsApp, quickMessage } from "../lib/site";

export default function Footer() {
  return (
    <footer className="site-footer">
      <motion.div className="footer-wordmark"
        initial={{ y: 80, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true, margin: "-100px" }} transition={{ duration: 1.2, ease: [0.22, 0.61, 0.36, 1] }}>
        Bhoomiza<sup>®</sup>
      </motion.div>
      <div className="footer-grid">
        <div className="footer-col">
          <p className="footer-brand-name">Bhoomiza Organics</p>
          <p className="footer-desc">Natural Moringa Powder, dehydrated fruits, dehydrated vegetables, natural powders and Moringa sweets — from a Jaipur-based brand, delivered across India.</p>
          <p className="footer-official">Official Website: <a href="https://www.bhoomizaorganics.com/" rel="noopener">https://www.bhoomizaorganics.com/</a></p>
        </div>
        <div className="footer-col">
          <p className="footer-col-title">Shop</p>
          <ul className="footer-links">
            <li><Link to="/shop">Shop All</Link></li>
            <li><Link to="/shop/moringa-powder">Moringa Powder</Link></li>
            <li><Link to="/shop/fruit-chips">Dehydrated Fruits</Link></li>
            <li><Link to="/shop/vegetable-chips">Dehydrated Vegetables</Link></li>
            <li><Link to="/shop/fruit-vegetable-powders">Fruit &amp; Vegetable Powders</Link></li>
            <li><Link to="/shop/moringa-sweets">Moringa Sweets</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <p className="footer-col-title">Company</p>
          <ul className="footer-links">
            <li><Link to="/about">About Bhoomiza Organics</Link></li>
            <li><Link to="/contact">Contact Bhoomiza Organics</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms &amp; Conditions</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <p className="footer-col-title">Connect</p>
          <ul className="footer-links">
            <li><a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">Instagram · @bhoomizaorganics</a></li>
            <li><a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer">YouTube · Bhoomiza Organics</a></li>
            <li><a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer">WhatsApp · +91 9672169073</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2026 Bhoomiza Organics · All rights reserved</span>
        <span>प्रकृति से, प्यार से.</span>
        <button onClick={() => openWhatsApp(quickMessage)} data-testid="footer-whatsapp-button"><MessageCircle size={16} /> WhatsApp us</button>
      </div>
    </footer>
  );
}
